<template>
<el-container>
  <el-header>
    <el-button type="success" @click="(e) => openAddNewQuestion(e)">
          Добавить новый вопрос
    </el-button> 
  </el-header>
  <div class="container-fluid" :class="classObject">
    <el-alert
      v-if="status === 200"
      :title="alertText"
      type="success"
      effect="dark"
    >
    </el-alert>

    <template>
      <el-table :data="faqs" empty-text="Нет данных" style="width: 100%">
        <el-table-column prop="id" label="Id" width="50"> </el-table-column>
        <el-table-column prop="question" label="Вопрос"> </el-table-column>
        <el-table-column prop="answer" label="Ответ"> </el-table-column>
        <el-table-column prop="sort" label="Сортировка"> </el-table-column>

        <el-table-column label="Активность">
          <template slot-scope="scope">
            <p v-if="!faqs[scope.$index].activity">Нет</p>
            <p v-if="faqs[scope.$index].activity">Да</p>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="Действия" width="400">
          <template slot-scope="scope">
            <div class="question-list">
              <el-button
                v-if="faqs[scope.$index].activity"
                size="mini"
                type="primary"
                plain
                @click="(e) => hideRow(e, faqs[scope.$index].id)"
                >Скрыть
              </el-button>
              <el-button
                v-if="!faqs[scope.$index].activity"
                size="mini"
                type="primary"
                plain
                @click="(e) => restoreRow(e, faqs[scope.$index].id)"
                >Показать
              </el-button>
              <el-button
                size="mini"
                @click="(e) => updateRow(e, faqs[scope.$index].id)"
                >Изменить
              </el-button>
              <el-popconfirm
                :title="'Удалить этот вопрос?'"
                :hide-icon="true"
                :confirmButtonText="'Да'"
                :cancelButtonText="'Нет'"
                @confirm="deleteRow(faqs[scope.$index].id)"
              >
                <template #reference>
                  <el-button
                    ref="removeBtn"
                    size="mini"
                    type="danger"
                    class="question__remove"
                  >
                    Удалить
                  </el-button>
                </template>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <faq-create-dialog @question-created="getFaqs" :section-id="sectionId"/>
    <faq-update-dialog
      v-if="question"
      :section-id="sectionId"
      :question="question"
      @question-redacted="getFaqs"
      :updateQuestion="updateQuestion"
    />
  </div>
  </el-container>
</template>

<script>
import axios from "axios";
import FaqCreateDialog from "@/components/Faq/FaqCreateDialog";
import FaqUpdateDialog from "@/components/Faq/FaqUpdateDialog";
import { SETPRELOADER_STATE } from "@/store/mutation-types";

export default {
  components: {
    FaqCreateDialog,
    FaqUpdateDialog,
  },
  props: {
    update: {
      type: Boolean,
    },
    sectionId: {
      type: Number,
      default: 0
    }
  },
  data: function () {
    return {
      status: 0,
      faqs: [],
      alertText: null,
      updateQuestion: false,
      question: null,
      isLoad: false,
      removeBtn: null,
          
    };
  },
  mounted() {
    this.getFaqs();
  },
  computed: {
    classObject() {
      return {
        questions__content: this.update,
      };
    },
  },
  methods: {
    getFaqs: function () {      
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .get("/faq/section/" + this.sectionId + "/question")
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          this.faqs = response.data.data.sort((a, b) => b.id - a.id);
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    getTarget(e) {
      const t = e.target;

      return t.classList.contains("el-button") ? t : t.parentNode;
    },
    hideRow: function (e, id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      const btn = this.getTarget(e);

      btn.style.pointerEvents = "none";

      axios
        .post("/faq/question/" + id + "/hide")
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          this.status = response.status;
          this.alertText = "Вопрос скрыт";

          this.faqs = [
            ...this.faqs.map((el) => {
              if (el.id === id) {
                el.activity = false;
              }

              return el;
            }),
          ];
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    restoreRow: function (e, id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      const btn = this.getTarget(e);

      btn.style.pointerEvents = "none";

      axios
        .post("/faq/question/" + id + "/restore")
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          this.status = response.status;
          this.alertText = "Вопрос восстановлен";
          btn.style.pointerEvents = "all";

          this.faqs = [
            ...this.faqs.map((el) => {
              if (el.id === id) {
                el.activity = true;
              }

              return el;
            }),
          ];
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    deleteRow: function (id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      axios
        .delete("/faq/question/" + id)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          this.status = response.status;
          this.alertText = "Вопрос успешно удален";

          this.faqs = [...this.faqs.filter((el) => el.id !== id)];
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    getFAQ(e, id) {
      const loader = setTimeout(() => {
        this.$store.commit(SETPRELOADER_STATE, true);
      }, 400);

      const btn = this.getTarget(e);

      btn.style.pointerEvents = "none";

      axios
        .get(`/faq/question/${id}`)
        .then((response) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);

          this.question = response.data;

          this.$store.commit("faqUpdateDialog", true);
          this.$store.commit("faqSectionId", id);

          btn.style.pointerEvents = "all";
        })
        .catch((errors) => {
          clearTimeout(loader);
          this.$store.commit(SETPRELOADER_STATE, false);
          btn.style.pointerEvents = "all";

          if (errors.response.status === 401) {
            this.$router.push("/login");
          }
        });
    },
    updateRow: function (e, id) {
      this.$store.commit("updateId", id);

      this.getFAQ(e, id);
    },
    openAddNewQuestion() {
      this.$store.commit("faqCreateDialog", true);
    },
  },
};
</script>

<style scoped>
.question__remove {
  margin-left: 10px;
}

.question-list {
  display: flex;
  justify-content: space-around;
}
</style>